import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase/firebase';

export const actualizarClasificacionAlumno = async (datos) => {
  const funcion = httpsCallable(getFunctions(app, 'us-central1'), 'actualizarClasificacionAlumno');
  const respuesta = await funcion(datos);
  return respuesta.data.alumnos;
};
